const api = "/api";
// const fee = "/fee";
// api列表
export const apis = {
  login: {
    login: `${api}/tenantUser/login`, // 登录---
    logout: `${api}/tenantUser/logOff`, // 登出
    changePwd: `${api}/tenantUser/userChangePassword`, // 修改密码---
    getUserInfo: `${api}/tenantUser/getTenantUserInfo`, // 获取用户信息
  },
  tenant: {
    getTenantList: `${api}/tenant/getTenantList`, // 获取商户列表---
    queryPageListParkLots: `${api}/parkLot/queryPageListParkLots`, // 获取停车场列表---
    queryParkVehicle: `${api}/parkVehicle/findParkVehicle`, // 在场车辆---
    // queryParkOrder: `${api}/order/queryOrder`, // 订单查询---,
    queryParkOrder: `${api}/order/queryOrderV2`, // 订单查询---,
    getOrder: `${api}/order/getOrder`, // 获取订单---,
    queryUser: `${api}/tenantUser/query`, // 人员查询---
    updateOrder: `${api}/order/orderUpdate`, // 订单编辑---
    queryDiscount: `${api}/businessCoupon/getUserCouponByPlateNumber`, // 折扣卷查询
    treeSentryBox: `${api}/sentryBox/treeSentryBox`, // 权限树状图
    queryParkLotGate: `${api}/parkLotGate/queryParkLotGate`, // 查询道闸
    findPassRecord: `${api}/businessManage/findPassRecord`,
    queryUserSch: `${api}/sentryBoxSchedule/queryUserSch`, //岗亭排班时间段
    curlSentryUserConfig: `${api}/sentryBox/curlSentryUserConfig`, //岗亭人员配置参数
    listTenantUserSentryBox: `${api}/sentryBox/listTenantUserSentryBox`, //列出收费员有排班的所有岗亭
    refreshSentryCashier: `${api}/sentryBox/refreshSentryCashier`, //刷新岗亭收费员信息
    billCarSize: `${api}/billCarSize/query`, //车辆类型
    report: `${api}/order/report`, //重播
    listUpdateVersion: `${api}/announcement/listUpdateVersion`, //发布信息列表
    checkVersion: `${api}/announcement/checkVersion`, //检查版本
    queryOpenGateFailedRecord: `${api}/parkPassing/queryOpenGateFailedRecord`, //相机识别未开闸记录
  },
  park: {
    carPass: `${api}/parkPass/carPass`, // 手动入场---
    openGate: `${api}/order/openGate`, // 免费开闸--
    confirmOrderMoney: `${api}/order/confirmOrderMoney`, // 确认收费
    queryCliVersion: `${api}/client/queryCliVersion`, // 查询客户端版本
    closeGate: `${api}/order/closeGate`, // 手动关闸
    videoList: `${api}/client/videoList`, // 道闸视频列表
    outPassType: `${api}/outPassType/query`, // 出场类型
    getSentryStatement: `${api}/statement/getSentryStatement`, //岗亭信息
    scanPay: `${api}/cashFlow/scanPay`, // 扫码支付
    lockGate: `${api}/client/lockGate`, //锁闸
    unLockGate: `${api}/client/unLockGate`, //锁闸解锁
    clearParkingCar: `${api}/order/clearParkingCar`, //清除在场车辆
    setSpotCanUseNum: `${api}/parkLot/setSpotCanUseNum`, //余位设置
    queryParkLotDetailById: `${api}/parkingLotDetailInfo/queryParkLotDetailById`, //查询余位
    queryParkLotGateCam: `${api}/parkLotGate/queryParkLotGateCam`, //相机监控
    queryParkLotBoxInfo: `${api}/parklotbox/queryParkLotBoxInfo`, //盒子监控
    getCurrentTenant: `${api}/payConfig/queryLoginDomain`, //Domain
    sortParkLotGate: `${api}/sentryBox/sortParkLotGate`, //出入口视频排序
    sortSentryStatField: `${api}/sentryBox/sortSentryStatField`, //岗亭统计金额字段排序
    openSurePassIn: `${api}/parkPassing/openSurePassIn`, //二次确认进场
    openForbidPassIn: `${api}/parkPassing/openForbidPassIn`, //二次确认进场 禁止入场
    queryCamFactory: `${api}/parkLotGate/queryCamFactory`, //厂商
  },
};

// 白名单
export const whiteList = [
  apis.login.login,
  apis.login.logout,
  apis.login.changePwd,
  apis.login.getUserInfo,
  apis.tenant.getTenantList,
  apis.tenant.queryPageListParkLots,
  apis.tenant.queryParkVehicle,
  apis.tenant.queryUser,
  apis.tenant.queryParkOrder,
  apis.tenant.getOrder,
  apis.tenant.queryDiscount,
  apis.tenant.treeSentryBox,
  apis.tenant.queryUserSch,
  apis.tenant.curlSentryUserConfig,
  apis.tenant.getSentryStatement,
  apis.tenant.listTenantUserSentryBox,
  apis.park.queryCliVersion,
  apis.park.videoList,
];
export const setTenantIdList=[apis.tenant.queryParkOrder,apis.tenant.queryParkLotGate,apis.tenant.getOrder]
